<template>
  <div ref="container">
    <div ref="sentinel" class="sentinel"></div>
    <div :class="{ fixed: isFixed }" class="sticky-nav">
      <slot />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onBeforeUnmount } from "vue";

export default defineComponent({
  name: "StickyNavigation",
  props: {
    parentSelector: {
      type: String,
      required: true, // 예: "#apt-trade-wrapper"
    },
  },
  data() {
    return {
      isFixed: false,
      observer: null as IntersectionObserver | null,
    };
  },
  mounted() {
    const sentinel = this.$refs.sentinel as HTMLElement;
    const parent = document.querySelector(this.parentSelector);

    if (!sentinel || !parent) return;

    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.isFixed = !entry.isIntersecting;
      },
      {
        root: null,
        threshold: 0,
        rootMargin: "0px 0px -10px 0px", // footer와 약간 겹치기 전에 해제
      }
    );

    this.observer.observe(sentinel);
  },
  beforeUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
});
</script>

<style scoped>
.sticky-nav {
  background: var(--t-bg-surface);
  transition: all 0.2s ease;
}

.fixed {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.3);
}

.sentinel {
  height: 1px;
}
</style>
